export function delay(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    return setTimeout(resolve, milliseconds);
  });
}
